import React, {ReactElement, useState} from "react"
import Grid from "@mui/material/Grid";
import {Position} from "../../Position";
import {IPosition} from "../../../../Store/interfaces/position.interface";
import {Button} from "../../../../App/components/Button";

interface Props {
  onClose: (position: IPosition) => void
}

export function Create(props: Props): ReactElement | null {
  const { onClose } = props
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <Grid item>
      <Button
        size="large"
        type="button"
        onClick={handleOpen}
      >
        Добавить
      </Button>
      {open ? (
        <Position
          open={open}
          onClose={(position?: IPosition) => {
            if (position) {
              onClose(position)
            }
            setOpen(false);
          }}
        />
      ): null}
    </Grid>
  )
}
